import { ComponentType } from "react";
import { styled } from "@mui/material/styles";
import { ListItemText, ListItemTextProps } from "@mui/material";
import { theme } from "themes/theme";

interface ICMenuItemText extends ListItemTextProps {
  isChild?: boolean;
  secondary?: boolean;
  isChosenParent?: boolean;
  isSelected?: boolean;
  level?: number;
}
export const CMenuItemText = styled<ComponentType<ListItemTextProps>>(
  ListItemText
)((props: ICMenuItemText) => ({
  fontSize: "0.90rem",
  fontWeight: props.isSelected || props.isChosenParent ? "bold" : "normal",
  color: props.isSelected
    ? props.secondary
      ? theme.palette.primary.main
      : "white"
    : "black",
  marginLeft: props.isChild ? (props.level ? (props.level + 1) * 16 : 32) : 16,
}));
